/**
 * 
 * @returns 
 */
export const viralSweepsForm = () => ({
    catchExportUrl(url) {
        vs_prefill_field('27418_1750991490', url)
    }
})